import {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetProblemsQuery, useUpdateProblemMutation } from '../slices/zabbixApiSlice';
import '../assets/styles/directory.css';
import praiseHimImg from '../assets/praise_him.png';



const ProblemScreen = () => {
  const navigate = useNavigate();
  const {userInfo} = useSelector((state) => state.auth);
  useEffect(() => {
      if(!userInfo){
          navigate('/login');
      }
  }, [userInfo, navigate])


  const {data: data, isLoading, error, refetch} = useGetProblemsQuery(undefined, {
    skip: !userInfo
  });
  const [ updateProblem ] = useUpdateProblemMutation();
  const [problems, setProblems] = useState(data);

  useEffect(() => {
    if (!userInfo) return;
    const interval = setInterval(() => {
      refetch();
    }, 60000);
    return () => clearInterval(interval);
  }, [userInfo, refetch]);

  useEffect(() => {
    if(data){
      setProblems(data);
    }
  }, [data]);

  const ackAlert = async (eventId) => {
    console.log(eventId);
    const res = await updateProblem({eventId: eventId}).unwrap();
    if(res.resp === "OK"){
      refetch();
    }
  }


  
  if (!userInfo) {
    return null;
  }

  return (
    <>
    {isLoading ? (
        <div className="text-center py-5">
            <h2 className="text-white">Loading Systems Status...</h2>
        </div>
    ): error ? (
        <div className="text-center py-5">
            <h2 className="text-danger">{error?.data?.message || error.error}</h2>
        </div>
    ) : (
        <div className="modern-directory-container">
            {/* Header Block */}
            <div className="directory-header-block flex-column flex-md-row align-items-start align-items-md-end gap-3">
                <div>
                    <div className="directory-tag">Network Status</div>
                    <h1 className="directory-title">Active System Problems</h1>
                    <p className="directory-subtitle">
                        Real-time Zabbix monitoring alerts, host issues, and downtime trackers. Acknowledge events to update status.
                    </p>
                </div>
            </div>

            {problems && problems.length > 0 ? (
                <div className="problem-container">
                    {problems.map((problem) => (
                        <div 
                            key={problem.eventId} 
                            className={`problem-card ${problem.acknowledged === '1' ? 'acknowledged-alert' : ''}`}
                        >
                            <div>
                                <span className="field-label">HOST</span>
                                <span className="field-value">{problem.hostName}</span>
                            </div>
                            <div>
                                <span className="field-label">Problem</span>
                                <span className="field-value problem-desc">{problem.problem}</span>
                            </div>
                            <div>
                                <span className="field-label">Downtime</span>
                                <span className="field-value">{problem.clock}</span>
                            </div>
                            <div>
                                {problem.acknowledged === '1' ? (
                                    <div className="btn-ack-status">Acknowledged</div>
                                ) : (
                                    <button 
                                        className="btn-zabbix" 
                                        id={problem.eventId} 
                                        onClick={() => ackAlert(problem.eventId)}
                                    >
                                        Acknowledge
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 empty-problems-panel">
                    <img 
                        src={praiseHimImg} 
                        alt="Praise Him" 
                        className="praise-him-image" 
                    />
                </div>
            )}
        </div>
    )}
    </>
  )
}

export default ProblemScreen;